export default "__VITE_ASSET__DDkuD1Ob__"